<template lang="pug">
.menu.briq-menu-panel.type-standard
  a.menu-option(:href="helpCenter") Help Center
  a.menu-option(:href="tutorials") Tutorials
  a.menu-option(:href="whatsNew") What's new?
</template>

<script>
export default {
  name: 'BriqHelpMenu',
  computed: {
    helpCenter() {
      return 'https://support.briqbookings.com/'
    },
    tutorials() {
      return 'https://support.briqbookings.com/en/support/solutions/77000206602'
    },
    whatsNew() {
      return 'https://www.briqbookings.com/release-updates'
    },
  },
}
</script>

<style scoped lang="stylus">
.menu
  position absolute
  bottom 112px
  right -226px
  width 232px

  &::after
    content ''
    width 0
    height 0
    border-style solid
    border-width 7px 8px 7px 0
    border-color transparent #2c333a transparent transparent
    display block
    position absolute
    left -8px
    bottom 20px

.briq-menu-panel
  color white
  margin 0
  padding 10px 0
  width 232px
  border-radius 3px
  background-color #2c333a
  box-shadow 0 2px 4px 0 rgba(0, 0, 0, 0.15)

.menu-option
  color white
  padding 6px 20px
  display block
  cursor pointer

  &:hover
    color white
    background #343c43
</style>
